export default "__VITE_ASSET__Dqar4p1X__"